import { RoleType } from '@tribeplatform/gql-client/types'

const paths = [
  '/auth/login',
  '/auth/login/direct',
  '/auth/signup',
  '/auth/accept',
  '/auth/join/:id',
  '/auth/reset-password',
  '/auth/forgot-password',
]
export const redirectIfLoggedIn = (roleType: RoleType) => {
  const authPath = paths.indexOf(window.location.pathname) > -1
  if (authPath && roleType !== RoleType.guest) {
    window.location.href = '/'
    return true
  }

  return false
}
